<mat-chip-list *ngIf="!!extended">
  <mat-chip [color]="status?.level" class="mat-chip-sm text-truncate"
            selected>{{getStatusText() | translate:{value: status?.value} }}</mat-chip>
</mat-chip-list>

<button #tooltip="matTooltip" (click)="tooltip.toggle(); $event.stopPropagation()" *ngIf="!(!!extended)" class="my-auto"
        mat-icon-button matTooltip="{{getStatusText() | translate:{value: status?.value} }}">
  <mat-icon [color]="status?.level" [fontIcon]="icons[status?.level]" fontSet="fas"></mat-icon>
</button>
